import { formatMoneyCHF } from '../../utils/priceUtils';

// Canonical CHF formatting lives in priceUtils. These delegate so the dashboard
// matches the rest of the admin ("CHF 1'234.50", symbol first, Swiss grouping).
export const formatMoney = (amount) => formatMoneyCHF(amount);

export const formatCompactMoney = (amount) => {
  const n = Number(amount) || 0;
  if (n >= 1000) {
    return `CHF ${(n / 1000).toFixed(n >= 10000 ? 0 : 1)}k`;
  }
  return formatMoneyCHF(n);
};

export const formatNumber = (n) => Number(n || 0).toLocaleString();

export const formatDate = (iso) => {
  if (!iso) return '-';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '-';
  return d.toLocaleDateString();
};

export const formatShortDate = (iso) => {
  if (!iso) return '-';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '-';
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
};

export const customerName = (o) => {
  const c = o?.customer || {};
  return [c.firstName, c.lastName].filter(Boolean).join(' ') || c.email || '-';
};

export const paymentStatusColor = (status) => {
  switch (status) {
    case 'paid':
      return 'bg-green-100 text-green-800';
    case 'pending':
      return 'bg-yellow-100 text-yellow-800';
    case 'failed':
      return 'bg-red-100 text-red-800';
    case 'voided':
      return 'bg-gray-200 text-gray-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

export const getDateRange = (preset) => {
  const to = new Date();
  const from = new Date();
  if (preset === 'today') {
    from.setHours(0, 0, 0, 0);
  } else if (preset === 'last7') {
    from.setDate(from.getDate() - 6);
    from.setHours(0, 0, 0, 0);
  } else {
    from.setDate(from.getDate() - 29);
    from.setHours(0, 0, 0, 0);
  }
  return { from: from.toISOString(), to: to.toISOString() };
};
